// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TsHL2ycT1ELG3X {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .TsHL2ycT1ELG3X {
    flex-direction: column;
    align-items: flex-start;
  }
}
.JJMEZXeHP9QLUy {
  display: flex;
  flex-direction: row;
}
.hcARpEtLZCp4i8 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 16px;
}
.j08FyOchIs4neh {
  border-radius: 3px;
}
.FkCbz8dwq8uNgi {
  min-width: 64px;
}
.J10DkvlRVMpQ3w {
  margin-top: 40px;
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: 0;
  margin-bottom: 0;
}
.HMVyomFqGJzxZ1 {
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: var(--ds-font-weight-regular, normal);
  line-height: 20px;
}
.G6HGrnluGayNwG {
  margin-top: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.G6HGrnluGayNwG .ppfNBzdeBiBD40 {
  color: var(--ds-text-subtle, #44546f);
  font-weight: var(--ds-font-weight-semibold, 600);
}
.G6HGrnluGayNwG .Ar0inZdjWkA56l {
  color: var(--ds-text-subtle, #44546f);
}
.xJ4yWPskk0BsaD {
  white-space: nowrap;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .xJ4yWPskk0BsaD {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    margin-top: 24px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `TsHL2ycT1ELG3X`,
	"templateHeaderInfo": `JJMEZXeHP9QLUy`,
	"headerText": `hcARpEtLZCp4i8`,
	"orgAvatar": `j08FyOchIs4neh`,
	"storyPageAvatar": `FkCbz8dwq8uNgi`,
	"templateName": `J10DkvlRVMpQ3w`,
	"creator": `HMVyomFqGJzxZ1`,
	"metadata": `G6HGrnluGayNwG`,
	"viewCopyText": `ppfNBzdeBiBD40`,
	"viewCopyIcon": `Ar0inZdjWkA56l`,
	"templateLink": `xJ4yWPskk0BsaD`
};
export default ___CSS_LOADER_EXPORT___;
